
import { addPageInWP } from "@/lib/singularity/wp-page-manager/pages";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon
  }
})
export default class WPPageManagerAddPage extends Vue {
  pageTitle = "";
  toggleAdd = false;

  adding = false;
  async addPage() {
    this.adding = true;

    if (!this.pageTitle.trim()) {
      this.adding = false;
      return;
    }

    await addPageInWP(this.pageTitle, {}, "page");
    this.pageTitle = "";

    this.adding = false;
  }

  mounted() {
    this.$nextTick(() => {
      (this.$refs.newPageInput as HTMLInputElement).focus();
    });
  }
}
